export default __webpack_public_path__ + "static/media/BG-Red-0006.4e39661b.png";